import AutocompleteWithQuery, {
  AutocompleteWithQueryProps,
} from "components/AutocompleteWithQuery";
import useGlobalContext from "hooks/globalData";
import { useIntl } from "react-intl";
import { useQuery } from "react-query";
import {
  ListRequestOfBaseFilter,
  ListResponseOfSkuStatus,
  SkuAvailability,
} from "services/KnowfullyAdminClient";

type SelectSkuStatusProps = Omit<
  AutocompleteWithQueryProps<SkuAvailability>,
  "fetchedData" | "failMessage" | "labelField"
>;

const SelectSkuStatus = ({ ...rest }: SelectSkuStatusProps) => {
  const { formatMessage: t } = useIntl();
  const { skuService } = useGlobalContext();

  const fetchedSkuStatuses = useQuery<ListResponseOfSkuStatus>(
    ["skuService.getSkuStatuses"],
    () =>
      skuService.getSkuStatuses(
        ListRequestOfBaseFilter.fromJS({
          sortField: "displayOrder",
        })
      )
  );

  return (
    <AutocompleteWithQuery
      {...rest}
      labelField="name"
      fetchedData={fetchedSkuStatuses}
      failMessage={t({ id: "selectSkuStatusFetchFailed" })}
    />
  );
};

export default SelectSkuStatus;
